import { Parser } from 'rich-string-parser/lib/types'

export function MarkdownItalicParser(): Parser<'MarkdownItalicParser'> {
  const regex = /[*]{1}(\S+)[*]{1}/m

  return {
    parse: (text) => {
      const result = regex.exec(text)
      if (result === null) return null

      return {
        type: 'MarkdownItalicParser',
        match: result[0],
        result: result[1],
        index: result.index,
      }
    },
  }
}

export function MarkdownBoldParser(): Parser<'MarkdownBoldParser'> {
  const regex = /[*]{2}(\S+)[*]{2}/m

  return {
    parse: (text) => {
      const result = regex.exec(text)
      if (result === null) return null

      return {
        type: 'MarkdownBoldParser',
        match: result[0],
        result: result[1],
        index: result.index,
      }
    },
  }
}

export function MarkdownLinksParser(): Parser<'MarkdownLinksParser'> {
  const regex = /(\[.*\])(\((http)(?:s)?(:\/\/).*\))/m

  return {
    parse: (text) => {
      const result = regex.exec(text)
      if (result === null) return null

      return {
        type: 'MarkdownLinksParser',
        match: result[0],
        parts: [
          result[1].substring(1, result[1].length - 1),
          result[2].substring(1, result[2].length - 1),
        ],
        index: result.index,
      }
    },
  }
}

export function MarkdownImageLinkParser(): Parser<'MarkdownImageLinkParser'> {
  const regex = /(!)(\[(?:.*)?\])(\(.*(\.(jpg|png|gif|tiff|bmp)))\)/m

  return {
    parse: (text) => {
      const result = regex.exec(text)
      if (result === null) return null

      return {
        type: 'MarkdownImageLinkParser',
        match: result[0],
        parts: [
          result[2].substring(1, result[2].length - 1),
          result[3].substring(1, result[3].length),
        ],
        index: result.index,
      }
    },
  }
}

export function MarkdownBreakLineParser(): Parser<'MarkdownBreakLineParser'> {
  const regex = /(<br\/>)/m

  return {
    parse: (text) => {
      const result = regex.exec(text)
      if (result === null) return null

      return {
        type: 'MarkdownBreakLineParser',
        match: result[0],
        index: result.index,
      }
    },
  }
}
